/**
 * 
 * @param {Object} object - JSON object to modify
 * @param {string[]} paths - List of key paths in dot notation to format
 * @param {string} type - remove or add : remove dashes or add dashes
 * @returns {void}
*/
export const formatPhoneNumbers = (obj, type='remove', paths) => {
    paths.forEach(path => {
        const keys = path.split('.');
        const keyToEdit = keys[keys.length - 1];
        let current = obj;

        for (let i = 0; i < keys.length - 1; i++){
            if (current[keys[i]] == undefined){
                return;
            }
            current = current[keys[i]]
        }

        if (typeof current[keyToEdit] === "string") {
            if (type == 'remove') {
                current[keyToEdit] = current[keyToEdit].replace(/-/g, "");
            } else if (!!current[keyToEdit]) {
                current[keyToEdit] =  current[keyToEdit].slice(0,3)+"-"+current[keyToEdit].slice(3,6)+"-"+current[keyToEdit].slice(6);
            }
        }
    });
}

export const formatTimestampToStr = (date) => {
    var enrolled_readable_date = new Date(date);
    let month = (enrolled_readable_date.getMonth() + 1).toString().padStart(2, '0');
    let day = enrolled_readable_date.getDate().toString().padStart(2, '0');
    let year = enrolled_readable_date.getFullYear();
    return month + '-' + day + '-' + year;
}